// Copyright (c) Tangible It, Mexico. All rights reserved.
// Licensed under the MIT License.

import React, { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";

import { IndentIcon, NumberListIcon } from "@fluentui/react-icons-northstar";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";

import {
  Text,
  Card,
  Image,
  Button,
  Label,
  Flex,
  Dropdown,
} from "@fluentui/react-northstar";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { IconButton } from "@fluentui/react";

import ReportsImage from "../../../Assets/images/reports.jpg";
import { useChartContext } from "../../../context/ChartContext";

import "./Layout.scss";
import { FormControl, Menu, MenuItem, Select } from "@mui/material";
import * as Icon from "react-feather";

const Layout = (props) => {
  const { isReportAvailable, children, t } = props;

  const {
    reportOptions,
    selectedType,
    setSelectedType,
    isFullscreen,
    setIsFullscreen,
    selectedReportPath,
    setSelectedReportPath,
    selectedStudent,
    setSelectedStudent,
    selectedTeacher,
    setSelectedTeacher,
  } = useChartContext();

  const [isCompactMode, setIsCompactMode] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedReport, setSelectedReport] = useState("");
  const { pathname } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (selectedReportPath === `event-report-by-category`) {
      setSelectedReport("Category");
    } else if (selectedReportPath === `event-report-by-tag`) {
      setSelectedReport("Tags");
    } else if (selectedReportPath === `attendance-report-by-subject`) {
      setSelectedReport("Subject");
    } else if (selectedReportPath === `attendance-report-by-student`) {
      setSelectedReport("Student");
    } else if (selectedReportPath === `attendance-report-by-teacher`) {
      setSelectedReport("Teacher");
    } else if (selectedReportPath === `attendance-special-report`) {
      setSelectedReport("Special");
    } else if (selectedReportPath === `attendance-student-progress-report`) {
      setSelectedReport("Progress");
    } else if (selectedReportPath === `assignment-report-by-subject`) {
      setSelectedReport("Subject");
    } else if (selectedReportPath === `assignment-report-by-student`) {
      setSelectedReport("Student");
    } else if (selectedReportPath === `assignment-report-by-teacher`) {
      setSelectedReport("Teacher");
    } else if (selectedReportPath === `feedback-report`)
      setSelectedReport("Feedback");
  }, [selectedReportPath]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleReportClick = (report, index) => {
    setSelectedReportPath(report.path);
    handleClose();
    // history.push(`/dashboard/${report.path}`);
    if (selectedStudent) {
      if (
        ![
          "attendance-report-by-student",
          "attendance-student-progress-report",
        ].includes(report.path)
      ) {
        const newReports = selectedType.reports.filter(
          ({ key }) => !["studentProgressReport"].includes(key)
        );
        setSelectedType({
          ...selectedType,
          reports: newReports,
        });
      }
    }

    if (selectedTeacher) {
      if (
        ![
          "attendance-report-by-teacher",
          "attendance-teacher-data-report",
        ].includes(report.path)
      ) {
        setSelectedTeacher(null);
        const newReports = selectedType.reports.filter(
          ({ key }) => key !== "teacherDataReport"
        );
        setSelectedType({
          ...selectedType,
          reports: newReports,
        });
      }
    }
  };

  // useEffect(() => {
  //   let selectedReport = reportOptions.find((item) =>
  //     item.reports.some((report) => `/dashboard/${report.path}` === pathname)
  //   );

  //   if (selectedReport) {
  //     if (!document.querySelector(".chart-layout.h-cls")) {
  //       document.querySelector(".chart-layout").classList.add("h-cls");
  //     }
  //   }
  //   setSelectedType(selectedReport);
  // }, []);

  const onCompactModeHandler = () => {
    setIsCompactMode(!isCompactMode);
  };

  const styles = {
    cardImg: {
      // width: "72px",
      height: "56px",
      right: "220px",
      marginLeft: "6px",
      marginTop: "6px",
      marginBottom: "6px",
      borderRadius: "7px",
    },
  };

  const myCard = (reportType) => {
    const cardToolTip = reportType.content;
    const reportTitle = reportType.content;
    return (
      <Card
        key={reportTitle}
        // className={
        //   reportType.type ===
        //   reportOptions.find((item) =>
        //     item.reports.some(
        //       (report) => `/dashboard/${report.path}` === pathname
        //     )
        //   )?.type
        //     ? "selectedCard"
        //     : "card"
        // }
        className={
          reportType.type === selectedType?.type ? "selectedCard" : "card"
        }
        compact
        horizontal
        aria-roledescription="ACV - Asistente de clases virtuales | Tangible IT"
        onClick={async () => {
          if (reportType.reports?.length && reportType?.reports[0]?.url) {
            // For AI reports, change the path to the AI report path
            history.push(`/dashboard/${reportType?.reports[0]?.path}`);
            handleClose();
            return;
          }
          if (!document.querySelector(".chart-layout.h-cls")) {
            document.querySelector(".chart-layout").classList.add("h-cls");
          }
          // let firstReport = reportType.reports?.length
          //   ? reportType.reports[0]
          //   : null;

          // if (firstReport) {
          //   history.push(`/dashboard/${firstReport.path}`);
          // }
          history.push(`/dashboard`);
          setSelectedType(reportType);
        }}
      >
        {isCompactMode && (
          <ReactTooltip
            place="right"
            type="light"
            effect="float"
            multiline={true}
          />
        )}
        <Card.Preview horizontal data-tip={cardToolTip}>
          <Image style={styles.cardImg} src={reportType.image} />
        </Card.Preview>

        <Card.Column className={isCompactMode ? "d-none" : ""}>
          <Card.Header>
            <Flex gap="gap.small">
              <Text
                content={reportType.content}
                weight="semibold"
                style={{ marginTop: "6px" }}
              />
            </Flex>
            {!reportType.reports[0].url && (
              <Text
                content={`${reportType.reports?.length} ${
                  t("chart").layout.reports
                }`}
                size="small"
              />
            )}
          </Card.Header>
        </Card.Column>
      </Card>
    );
  };

  /* Close fullscreen */
  function closeFullscreen() {
    try {
      if (document.fullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          /* Safari */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE11 */
          document.msExitFullscreen();
        }
      }
      setIsFullscreen(false);
    } catch (err) {
      console.log(err);
    }
  }
  /* View in fullscreen! */
  function openFullscreen() {
    var elem = document.documentElement;
    try {
      if (!document.fullscreenElement) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Safari */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE11 */
          elem.msRequestFullscreen();
        }
      }
      setIsFullscreen(true);
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="layout-wrapper">
      <div className="chart-layout h-ctr">
        <div
          style={{
            width: "100%",
            backgroundColor: "white",
          }}
        >
          <Flex fill className="available-reports-chart-wrapper">
            {!isReportAvailable && !!reportOptions?.length && (
              <Flex
                gap="gap.medium"
                className={`tour-select-lesson ${
                  isCompactMode ? "availableClass mr-0" : "availableClass"
                }`}
              >
                <div
                  style={{
                    paddingTop: "18px",
                    width: isCompactMode ? "auto" : "280px",
                    paddingLeft: "40px",
                    marginRight: "0px",
                  }}
                >
                  <Label
                    style={{ color: "#252423", cursor: "pointer" }}
                    iconPosition="start"
                    icon={isCompactMode ? <IndentIcon /> : <NumberListIcon />}
                    content={
                      isCompactMode ? (
                        ""
                      ) : (
                        <Text
                          content={t("chart").layout.availableReports}
                          size="medium"
                          weight="semibold"
                          style={{ marginLeft: "4px" }}
                        />
                      )
                    }
                    color="white"
                    onClick={() => onCompactModeHandler()}
                  />
                </div>

                <div
                  className={`${
                    isCompactMode
                      ? "report-class-wrapper w-125"
                      : "report-class-wrapper"
                  }`}
                >
                  <ul className={isCompactMode ? "pl-10" : "pl-sm-1"}>
                    {reportOptions.map((report) => myCard(report))}
                  </ul>
                </div>
              </Flex>
            )}
            {selectedType ? (
              <Flex column className="report-wrapper" gap="gap.medium">
                {props.isMobileView ? (
                  <Flex
                    className={`title-report-option-wrapper ${
                      isFullscreen ? "full-screen" : ""
                    }`}
                  >
                    <Flex gap="gap.small" vAlign="center">
                      <IconButton
                        iconProps={{
                          iconName: "ChromeBack",
                          styles: {
                            root: { fontSize: "18px", fontWeight: "500" },
                          },
                        }}
                        style={{ marginRight: "5px" }}
                        title={t("chart").layout.back}
                        ariaLabel={t("chart").layout.back}
                        onClick={() => {
                          if (
                            [
                              "attendance-student-progress-report",
                              "attendance-teacher-data-report",
                            ].includes(selectedReportPath)
                          ) {
                            setSelectedReportPath(
                              selectedReportPath ===
                                "attendance-teacher-data-report"
                                ? "attendance-report-by-teacher"
                                : "attendance-report-by-student"
                            );
                          } else {
                            if (selectedStudent) {
                              setSelectedStudent(null);
                              if (selectedType.type === "attendance") {
                                const newReports = selectedType.reports.filter(
                                  ({ key }) => key !== "studentProgressReport"
                                );
                                setSelectedType({
                                  ...selectedType,
                                  reports: newReports,
                                });
                              }
                            }
                            if (selectedTeacher) {
                              setSelectedTeacher(null);
                              if (selectedType.type === "attendance") {
                                const newReports = selectedType.reports.filter(
                                  ({ key }) => key !== "teacherDataReport"
                                );
                                setSelectedType({
                                  ...selectedType,
                                  reports: newReports,
                                });
                              }
                            }
                            if (
                              pathname === "/dashboard" &&
                              document.querySelector(".chart-layout.h-cls")
                            ) {
                              document
                                .querySelector(".chart-layout")
                                .classList.remove("h-cls");
                              setSelectedReportPath("");
                            }

                            if (
                              pathname === "/dashboard" &&
                              !selectedReportPath
                            ) {
                              setSelectedType(null);
                            }
                            if (
                              pathname === "/dashboard" &&
                              selectedReportPath
                            ) {
                              setSelectedReportPath("");
                            }
                          }
                          // history.push("/dashboard");
                        }}
                      />

                      <Text weight="semibold" size="larger">
                        {selectedType.content}
                      </Text>

                      <Button
                        onClick={handleClick}
                        primary={pathname !== `/dashboard`}
                        style={{
                          borderRadius: "24px",
                          margin: "0px",
                          marginLeft:
                            pathname === `/dashboard` ? "0px" : "45px",
                          marginRight:
                            pathname === `/dashboard` ? "0px" : "0px",
                        }}
                      >
                        {selectedReport ? `${selectedReport}` : "Select Report"}
                      </Button>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        {selectedType?.reports?.map((report, index) => (
                          <MenuItem
                            key={report.key}
                            selected={`${report.path}` === selectedReportPath}
                            onClick={() => {
                              handleReportClick(report, index);
                            }}
                          >
                            {report.title}
                          </MenuItem>
                        ))}
                      </Menu>

                      <Button
                        text
                        circular
                        icon={
                          isFullscreen ? (
                            <FullscreenExitOutlined />
                          ) : (
                            <FullscreenOutlined />
                          )
                        }
                        onClick={
                          isFullscreen ? closeFullscreen : openFullscreen
                        }
                        title={
                          isFullscreen ? "Close Full Screen" : "Full Screen"
                        }
                        className={
                          props.isMobileView
                            ? "mobile-chart-expand-screen"
                            : "chart-expand-screen"
                        }
                      />
                    </Flex>
                  </Flex>
                ) : (
                  <Flex
                    className={`title-report-option-wrapper ${
                      isFullscreen ? "full-screen" : ""
                    }`}
                  >
                    <Flex gap="gap.small" vAlign="center">
                      <IconButton
                        iconProps={{
                          iconName: "ChromeBack",
                          styles: {
                            root: { fontSize: "18px", fontWeight: "500" },
                          },
                        }}
                        style={{ marginRight: "5px" }}
                        title={t("chart").layout.back}
                        ariaLabel={t("chart").layout.back}
                        onClick={() => {
                          if (
                            [
                              "attendance-student-progress-report",
                              "attendance-teacher-data-report",
                            ].includes(selectedReportPath)
                          ) {
                            setSelectedReportPath(
                              selectedReportPath ===
                                "attendance-teacher-data-report"
                                ? "attendance-report-by-teacher"
                                : "attendance-report-by-student"
                            );
                          } else {
                            if (selectedStudent) {
                              setSelectedStudent(null);
                              if (selectedType.type === "attendance") {
                                const newReports = selectedType.reports.filter(
                                  ({ key }) =>
                                    !["studentProgressReport"].includes(key)
                                );
                                setSelectedType({
                                  ...selectedType,
                                  reports: newReports,
                                });
                              }
                            }
                            if (selectedTeacher) {
                              setSelectedTeacher(null);
                              if (selectedType.type === "attendance") {
                                const newReports = selectedType.reports.filter(
                                  ({ key }) => key !== "teacherDataReport"
                                );
                                setSelectedType({
                                  ...selectedType,
                                  reports: newReports,
                                });
                              }
                            }
                            if (
                              pathname === "/dashboard" &&
                              document.querySelector(".chart-layout.h-cls")
                            ) {
                              document
                                .querySelector(".chart-layout")
                                .classList.remove("h-cls");
                              setSelectedReportPath("");
                            }

                            if (
                              pathname === "/dashboard" &&
                              !selectedReportPath
                            ) {
                              setSelectedType(null);
                            }
                            if (
                              pathname === "/dashboard" &&
                              selectedReportPath
                            ) {
                              setSelectedReportPath("");
                            }
                          }
                          // history.push("/dashboard");
                        }}
                      />

                      <Text weight="semibold" size="larger">
                        {selectedType.content}
                      </Text>

                      {selectedType?.reports?.length && innerWidth > 1260
                        ? selectedType.reports.map((report, index) => {
                            return (
                              <Button
                                key={report.key}
                                primary={
                                  `${report.path}` === selectedReportPath
                                }
                                style={{ borderRadius: "24px" }}
                                onClick={() => {
                                  // history.push(`/dashboard/${report.path}`);
                                  // setSelectedReportPath(report.path);
                                  handleReportClick(report);
                                }}
                              >
                                {report.title}
                              </Button>
                            );
                          })
                        : selectedType?.reports?.length && (
                            <>
                              <Button
                                onClick={handleClick}
                                primary={pathname !== `/dashboard`}
                                style={{
                                  borderRadius: "24px",
                                  margin: "0px",
                                  marginLeft:
                                    pathname === `/dashboard` ? "0px" : "45px",
                                  marginRight:
                                    pathname === `/dashboard` ? "0px" : "0px",
                                }}
                              >
                                {selectedReport
                                  ? `${selectedReport}`
                                  : "Select Report"}
                              </Button>
                              <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                              >
                                {selectedType?.reports?.map((report, index) => (
                                  <MenuItem
                                    key={report.key}
                                    selected={
                                      `${report.path}` === selectedReportPath
                                    }
                                    onClick={() => {
                                      handleReportClick(report, index);
                                    }}
                                  >
                                    {report.title}
                                  </MenuItem>
                                ))}
                              </Menu>
                            </>
                          )}
                      {selectedReportPath !==
                        "attendance-student-progress-report" && (
                        <Icon.Filter
                          size="20"
                          className="ctrl mr-3"
                          style={{
                            marginTop: "-9px",
                          }}
                          onClick={() => {
                            if (document.querySelector(".h-ctr")) {
                              document
                                .querySelector(".h-ctr")
                                .classList.add("s-ctr");
                              document
                                .querySelector(".h-ctr")
                                .classList.remove("h-ctr");
                            } else if (document.querySelector(".s-ctr")) {
                              document
                                .querySelector(".s-ctr")
                                .classList.add("h-ctr");
                              document
                                .querySelector(".s-ctr")
                                .classList.remove("s-ctr");
                            }
                          }}
                        />
                      )}
                      <Button
                        text
                        circular
                        icon={
                          isFullscreen ? (
                            <FullscreenExitOutlined />
                          ) : (
                            <FullscreenOutlined />
                          )
                        }
                        onClick={
                          isFullscreen ? closeFullscreen : openFullscreen
                        }
                        title={
                          isFullscreen ? "Close Full Screen" : "Full Screen"
                        }
                        className="chart-expand-screen"
                      />
                    </Flex>

                    {/* <Flex
                      gap="gap.medium"
                      wrap
                      className="report-type-button-wrapper"
                    >
                      {selectedType?.reports?.length
                        ? selectedType.reports.map((report, index) => {
                            console.log("report", report);
                            return (
                              <Button
                                key={report.key}
                                primary={
                                  `${report.path}` === selectedReportPath
                                }
                                style={{ borderRadius: "24px" }}
                                onClick={() => {
                                  // history.push(`/dashboard/${report.path}`);
                                  setSelectedReportPath(report.path);
                                }}
                              >
                                {report.title}
                              </Button>
                            );
                          })
                        : null}
                    </Flex> */}
                  </Flex>
                )}

                {isReportAvailable ? (
                  children
                ) : (
                  <Flex
                    style={{ height: "100%", flexGrow: 1, marginTop: "30px" }}
                    hAlign="center"
                    vAlign="center"
                  >
                    <Image
                      src={ReportsImage}
                      style={{ maxWidth: "600px", width: "100%" }}
                    />
                  </Flex>
                )}
              </Flex>
            ) : (
              <Flex
                style={{ height: "100%", flexGrow: 1 }}
                hAlign="center"
                vAlign="center"
                className="chart-image-wrapper"
              >
                <Flex
                  column
                  style={{ height: "100%" }}
                  hAlign="center"
                  vAlign="center"
                >
                  <Image
                    src={ReportsImage}
                    style={{
                      maxWidth: "600px",
                      width: "100%",
                      marginTop: "50px",
                    }}
                  />
                  {!reportOptions?.length && (
                    <Text
                      size="large"
                      weight="semibold"
                      align="center"
                      className="no-available-report-text"
                    >
                      No Reports Available for you. Please contact to your
                      School.
                    </Text>
                  )}
                </Flex>
              </Flex>
            )}
          </Flex>
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(Layout);
